interface CalculateNextValueProps {
  current: number;
  max: number;
  min: number;
  step: number;
}

export function calculateNextValue() {
  let countUp = true;

  function count({ current, max, min, step }: CalculateNextValueProps) {
    if (countUp && current + step <= max) {
      countUp = true;
      return current + step;
    }

    if (current - step < min) {
      countUp = true;
      return current + step;
    }
    countUp = false;
    return current - step;
  }
  return count;
}

export function getMaxValue(value: number): number {
  // does not work with exponential number cast
  return parseInt('9'.repeat(Math.trunc(value).toString().length), 10);
}

export function getMinValue(value: number): number {
  // does not work with exponential number cast
  const zeros = '0'.repeat(Math.trunc(value).toString().length - 1);
  return parseInt(`1${zeros}`, 10);
}

export function getStepValue(value: number): number {
  return Math.round(Math.trunc(value) * 0.05);
}
